module.exports = __webpack_public_path__ + "media/images/icon/icon_hit-49b14bb2e3e7fe97caf78a01c1ca8857.png";